import React, { forwardRef } from "react";
import Form from "react-bootstrap/Form";

const Status = forwardRef<HTMLSelectElement, {tabIndex: number}>(
    ({ tabIndex, ...props }, ref) => {
        return (
            <Form.Group className="form-group filter-status">
                <Form.Label>
                    <span className="icon"></span>
                    Statut
                </Form.Label>
                <Form.Select id="filters-status-select" tabIndex={tabIndex} 
                    ref={ref}>
                    <option value="all" >Tous</option>
                    <option value="active">Actif</option>
                    <option value="inactive">Inactif</option>
                </Form.Select>
            </Form.Group>
        );
    }
);

export default Status;